export default __webpack_public_path__ + "static/media/2009.58f29c8d.png";